import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const generatePayroll = async ({
  companyCode,
  locationCode,
  month,
  year,
  userCode,
  salaryType,
  excludeTime,
}) => {
  if (companyCode && locationCode && month !== 0 && year !== 0) {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GeneratePayroll}?CompanyCode=${companyCode}&Month=${month}&Year=${year}&UserCode=${userCode}&LocationCode=${locationCode}&SalaryType=${salaryType}&ExcludeTime=${excludeTime} `,
    );

    return data;
  }

  return [];
};

export const useGeneratePayrollQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GeneratePayroll],
    queryFn: () => generatePayroll(input),
    refetchOnWindowFocus: false,
  });
};

const reGeneratePayroll = async (payload) => {
  if (
    payload?.companyCode &&
    payload?.locationCode &&
    payload?.month !== "" &&
    payload?.year !== "" &&
    payload?.userCode &&
    payload?.salaryType &&
    payload?.employeeCode &&
    payload?.refNo
  ) {
    const { data } = await http_payroll.post(
      Api_EndPoints.ReGenerateAndSavePayrollStaging,
      payload,
    );
    return data;
  }

  return [];
};

const reCalculateSalary = async (payload) => {
  if (
    payload?.companyCode &&
    payload?.locationCode &&
    payload?.month !== "" &&
    payload?.year !== "" &&
    payload?.userCode &&
    payload?.salaryType &&
    payload?.employeeCode &&
    payload?.basicSalary
  ) {
    const { data } = await http_payroll.post(
      Api_EndPoints.ReCalculatePayrollGeneration,
      payload,
    );
    return data;
  }
};

export const useReGeneratePayrollMutation = () => {
  return useMutation({
    mutationFn: reGeneratePayroll,
  });
};

export const useReCalculatePayrollGenerationMutation = () => {
  return useMutation({
    mutationFn: reCalculateSalary,
  });
};

